import { AppliedVoucher } from 'network/response/ICart';
import { getDiscountAmount } from '../Promo/Promo.helper';
import { IPromo } from 'pages/Checkout/redux/reducer/promo.reducer';
import { IVoucherCard } from '../AvailablePromotions/redux/AvailablePromotions.reducer';
import { createMarkup } from 'utils/html.util';
import { IVoucherCardVariant, VOUCHER_CARD_VARIANT } from '../VoucherCard/VoucherCard.constants';

export const isCouponCodeApplied = (couponCode: string, appliedPromo: AppliedVoucher | null) =>
  !!(appliedPromo && couponCode === appliedPromo.code);

export const isCouponCodeHasError = (couponCode: string, promoState: IPromo) =>
  couponCode === promoState.errorPromoCode;

const getVoucherCardVariant = ({
  isAppliedError,
  isApplicable,
}: {
  isAppliedError: boolean;
  isApplicable: boolean;
}): IVoucherCardVariant => {
  if (isAppliedError) {
    return VOUCHER_CARD_VARIANT.ERROR;
  } else if (isApplicable) {
    return VOUCHER_CARD_VARIANT.SUCCESS;
  } else {
    return VOUCHER_CARD_VARIANT.DISABLED;
  }
};

export const getBottomMessage = ({
  coupon,
  appliedPromo,
  promoState,
  t,
}: {
  appliedPromo: AppliedVoucher | null;
  promoState: IPromo;
  coupon: IVoucherCard;
  t: any;
}) => {
  let bottomMessage = '';
  const isApplied = isCouponCodeApplied(coupon.code, appliedPromo);
  const isAppliedError = isCouponCodeHasError(coupon.code, promoState);

  if (isApplied) {
    bottomMessage = t('promo.haveSavedMessage', {
      // @ts-ignore
      discount: getDiscountAmount(appliedPromo),
    });
  } else if (isAppliedError) {
    bottomMessage = promoState.error;
  } else {
    bottomMessage = coupon.bottomMessage;
  }

  return createMarkup(bottomMessage);
};

export const voucherCardDataMassaging = ({
  coupon,
  appliedPromo,
  promoState,
  t,
}: {
  appliedPromo: AppliedVoucher | null;
  promoState: IPromo;
  coupon: IVoucherCard;
  t: any;
}) => {
  const isApplied = isCouponCodeApplied(coupon.code, appliedPromo);
  const isAppliedError = isCouponCodeHasError(coupon.code, promoState);
  const bottomMessage = getBottomMessage({
    coupon,
    appliedPromo,
    promoState,
    t,
  });
  const variant = getVoucherCardVariant({
    isApplicable: coupon.isApplicable,
    isAppliedError,
  });

  return {
    isApplied,
    isAppliedError,
    bottomMessage,
    variant,
  };
};
